import classNames from "classnames";
import { FC, useCallback, useEffect, useState } from "react";

import OptionField from "@/components/GuidedToolLauncher/OptionField";
import RangeSelector from "@/components/GuidedToolLauncher/RangeSelector";
import { GuidedToolSlideProps, SearchParams } from "@/types";

import { useGuidedToolContext } from "./GuidedToolProvider";

const EditorialSlide: FC<GuidedToolSlideProps> = ({ slide }) => {
  const { setCurrentAnswer, setCurrentFilter, activeSlideId } = useGuidedToolContext();

  const [checkedStates, setCheckedStates] = useState<string[]>([]);

  const handleCheckChange = useCallback((id: string) => {
    setCheckedStates((prevState) => {
      let newCheckedStates;
      if (slide.variant === "single") {
        newCheckedStates = [id];
      } else {
        if (prevState.includes(id)) {
          newCheckedStates = prevState.filter((item) => item !== id);
        } else {
          newCheckedStates = [...prevState, id];
        }
      }

      return newCheckedStates;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (activeSlideId == slide.id) {
      if (slide.type == "editorial") {
        setCurrentAnswer(checkedStates);
      } else {
        if (slide.filterType === "location") {
          setCurrentFilter({ category: checkedStates.toString() } as SearchParams);
        } else {
          setCurrentFilter({ [slide.filterType as keyof SearchParams]: checkedStates.toString() } as SearchParams);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSlideId, checkedStates]);

  return slide.variant == "range" ? (
    <RangeSelector slide={slide} />
  ) : (
    <div className={classNames("grid gap-m md:gap-0 md:flex md:flex-wrap md:justify-between", { "grid-cols-2": slide.options.length >= 4 })}>
      {slide.options.map((option, index) => (
        <OptionField
          option={option}
          optionsLenght={slide.options.length}
          variant={slide.variant}
          key={option.id}
          isChecked={checkedStates.includes(slide.filterType === "location" ? option.id : option.title!) || false}
          onCheckChange={handleCheckChange}
          forwardId={slide.filterType === "location"}
        />
      ))}
    </div>
  );
};
export default EditorialSlide;
